<script type="text/javascript">
    import { createEventDispatcher } from 'svelte';
    import { fade, fly } from 'svelte/transition';
    import { onLogin, login, register } from "../Auth.svelte";

    import Reporter from "../lib/error.js";
    import Messages from "../components/form/Messages.svelte";
    import Message from "../components/form/Message.svelte";
    import Background from "../components/Background.svelte";
    import Button from "../components/form/Button.svelte";
    import ForgotPasswordLink from "../components/ForgotPasswordLink.svelte";
    import Notification from "../components/Notification.svelte";

    const dispatch = createEventDispatcher();

    export let isRegisterType = false;

    // credentials that can be used for both login and register
	let email = '';
	let password = '';

    // derived Credentials object
    // TODO: use class from generated SDK?
    $: credentials = {username: email, password: password};
    $: showForgotPasswordLink = email && email.includes("@") && email.includes(".");

	// for registration form
	let firstName;
	let lastName;

	// pending requests that we might want to show a status for in the view
    let credentialsRequest;
    let registrationRequest;
    let loginDeterminationRequest;

    let successMsg;
    let loginErrorMsg = "";
    let registerErrorMsg = "";

    // login = true
    // signup = false
    $: isLoginType = !isRegisterType;
    let isLoading = !!sessionStorage.getItem('token');

    // TODO: do not take the target from GET but from localstorage
    let params = new URLSearchParams(new URL(window.location.href).search);
    let target = params.get('target') || "/dashboard";

    // send message to outer component
    function redirectApp(trg) {
      dispatch('ok', trg || target);
    }

    function goToDashboard() {
      successMsg = "Successfully logged in";
      redirectApp("/dashboard");
    }

    function clearErrors() {
      loginErrorMsg = "";
      registerErrorMsg = "";
    }

	function handleLogin(event) {
	  registrationRequest = null;
	  clearErrors();

      credentialsRequest = login(credentials)

      .then(goToDashboard)

      .catch(err => {
        console.log(`received error on login:`);
	    console.log(err);

	    loginErrorMsg = "The combination of email and password did not match, or no account exists for this email address";

	    // TODO: handle other cases
      });
	}

	function handleRegistration(event) {
	  credentialsRequest = null;
	  clearErrors();

	  registrationRequest = register({
	    firstName: firstName,
	    lastName: lastName,
	    emailAddress: email,
	    // TODO
	    linkedInProfileName: "test",
	    credentials: credentials
	  })

      .then(res => {
        console.log(`received successful response from registration:`);
        console.log(res);

        // TODO: replace with lib func
        localStorage.setItem('token', res.data.registerUser.token);

        successMsg = "Successfully registered user account!";

        goToDashboard();
      })

	  .catch(err => {
	    console.log(`received error on registration:`);
	    console.log(err);

        // TODO: this is not caught when multiple errors happen
	    if (err.networkError.result.errors[0].message.includes("already taken")) {
	      registerErrorMsg = "The given email address has already been used";
	    }

	    else {
	      registerErrorMsg = "There was an unexpected error when trying to register. The given email address may already exist.";
	      throw err.networkError.result;
	    }
	  });
	}

    function formatError(msg) {
      //console.error(msg.errors[0].message);
      Reporter.error("Authentication error", msg);
      return "There was an authentication error. Check your credentials or contact support.";
    }
</script>

<!-- set HTML template title for this route -->
<svelte:head>
  <title>Evalueaid | Login</title>
</svelte:head>

<Background content="url('https://unsplash.com/photos/xfngap_DToE/download?force=true&w=1920')"/>

<div id="page-login">
  <div class="column-content-left" in:fly="{{ x: -1000, duration: 1500 }}">
    <div class="inner">
      <ul id="login-type-switcher">
        <li class="{isLoginType ? 'active' : ''}"><button on:click="{() => isLoginType = true}">Login</button></li>
        <li class="{!isLoginType ? 'active' : ''}"><button on:click="{() => isLoginType = false}">Sign up</button></li>
      </ul>

      {#if isLoginType}
        <h1>Login</h1>

        <div class="form">
          {#if loginErrorMsg}
            <div class="messages">
              <div class="message error">{loginErrorMsg}</div>
            </div>
          {/if}
          <input type="email" placeholder="your email" name="email" bind:value={email}/>
          <input type="password" placeholder="your password" name="password" bind:value={password}/>

          <Button type="submit"
                  id="login-button"
                  value="Login"
                  disable={!!credentialsRequest}
                  on:click={handleLogin}>
            {#await credentialsRequest}
              ...
            {:then}
              Login
            {/await}
          </Button>

          {#if showForgotPasswordLink}
            <ForgotPasswordLink {email} />
          {/if}
        </div>

      {:else}
        <h1>Register</h1>
        A password needs to be at least 6 characters, contain a capital letter and a special symbol.
        <div class="form">
          {#if registerErrorMsg}
            <div classes="messages">
              <div class="message error">{registerErrorMsg}</div>
            </div>
          {/if}
          <input type="text" placeholder="Your first name" name="firstName" bind:value={firstName}>
          <input type="text" placeholder="Your last name" name="lastName" bind:value={lastName}>
          <input type="email" placeholder="your email" name="email" bind:value={email}>
          <input type="password" placeholder="your password" name="password" bind:value={password}>
          <Button type="submit" id="register-button" value="Register" disable={!!registrationRequest} on:click={handleRegistration} />
        </div>
      {/if}
    </div>
  </div>
  <div class="column-background-right"></div>
</div>

<Notification message={successMsg} type="success" />

<style>

  #page-login {
    display: flex;
    flex-direction: row;
    height: 100%;
    color: white;
  }

  #login-type-switcher {
    display: flex;
    flex-direction: row;
    margin: 0;
    padding: 0;
    list-style-type: none;
    margin-bottom: 25px;
  }

  #login-type-switcher li {
    flex: 1;
  }

  #login-type-switcher li.active button {
    border-bottom: 3px solid #35db1e;
    //color: white;
  }

  #login-type-switcher li button {
    width: 100%;
  }

  .messages {
    margin-bottom: 10px;
  }

  .messages .message.error {
    padding: 5px;
    color: white;
    background: #c00;
    font-weight: bold;
  }

  .column-content-left {
    box-sizing: border-box;
    min-width: 50vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    height: 100%;
    background: rgba(4, 4, 4, 0.7);
    align-items: flex-end;
  }

  .column-content-left > .inner {
    box-sizing: border-box;
    min-width: 25vw;
    max-width: 400px;
    padding: 75px;
  }

  .form {
    display: flex;
    flex-direction: column;
  }

  .form input {
    padding: 15px 10px;
    margin-bottom: 15px;
  }

  .column-background-right {
    flex: 1;
    //background-image: url(https://unsplash.com/photos/xfngap_DToE/download?force=true&w=1920);
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
  }
</style>